import DataModel from '../common/model/DataModel';

export default class MemoEditorDataModel extends DataModel {
  constructor(locale, counterparty, parentDataModel, editorRights, memoDto, isNew) {
    super();

    this.locale = locale;
    this.counterparty = counterparty;
    this.parentDataModel = parentDataModel;
    this.editorRights = editorRights;

    this.isNew = isNew;
    this.isModified = isNew;

    this.guid = memoDto.guid;
    this.currentOnlyVisibleToPowerex = memoDto.onlyVisibleToPowerex;
    this.currentDisplayOrderIndex = memoDto.displayOrderIndex;
    this.currentHtmlContent = memoDto.htmlContent;

    this.enableEditVisibility = editorRights.canEditPowerexMemos
      && editorRights.canEditExternalMemos;
    this.enableEditContent = (editorRights.canEditPowerexMemos && editorRights.canEditExternalMemos)
      || (editorRights.canEditPowerexMemos && memoDto.onlyVisibleToPowerex)
      || (editorRights.canEditExternalMemos && !memoDto.onlyVisibleToPowerex);

    this.enableMoveUp = false;
    this.enableMoveDown = false;

    this.originalOnlyVisibleToPowerex = memoDto.onlyVisibleToPowerex;
    this.originalDisplayOrderIndex = memoDto.displayOrderIndex;
    this.originalHtmlContent = memoDto.htmlContent;
  }

  onPropertyUpdated(propertyName, oldValue, newValue) {
    switch (propertyName) {
      case 'isModified':
        this.parentDataModel.onMemoIsModifiedChanged(this);
        break;
      default:
        break;
    }
  }

  updateMemoDto(memoDto) {
    if (memoDto.guid !== this.guid)
      return;

    this.updateProperties({
      currentOnlyVisibleToPowerex: memoDto.onlyVisibleToPowerex,
      currentDisplayOrderIndex: memoDto.displayOrderIndex,
      currentHtmlContent: memoDto.htmlContent
    });
      
    this.originalDisplayOrderIndex = memoDto.displayOrderIndex;
    this.originalHtmlContent = memoDto.htmlContent;
    this.originalOnlyVisibleToPowerex = memoDto.onlyVisibleToPowerex;

    this.updateProperties({
      isNew: false,
      isModified: false
    });
  }

  getMemoDto() {
    return {
      counterpartyCode: this.counterparty.code,
      guid: this.guid,
      onlyVisibleToPowerex: this.currentOnlyVisibleToPowerex,
      displayOrderIndex: this.currentDisplayOrderIndex,
      htmlContent: this.currentHtmlContent
    }
  }

  resolveIsModified() {
    return this.isNew
      || this.currentDisplayOrderIndex !== this.originalDisplayOrderIndex
      || this.currentOnlyVisibleToPowerex !== this.originalOnlyVisibleToPowerex
      || this.currentHtmlContent !== this.originalHtmlContent;
  }

  toggleVisibility() {
    if (!this.enableEditVisibility)
      return;

    this.updateProperties({
      currentOnlyVisibleToPowerex: !this.currentOnlyVisibleToPowerex,
    });

    this.updateProperties({
      isModified: this.resolveIsModified()
    });
  }

  moveMemoUp() {
    if (!this.enableMoveUp)
      return;

    this.parentDataModel.onMemoMoveUp(this);
  }

  moveMemoDown() {
    if (!this.enableMoveDown)
      return;

    this.parentDataModel.onMemoMoveDown(this);
  }

  deleteMemo() {
    this.parentDataModel.onMemoDelete(this.guid);
  }

  setDisplayOrderIndex(displayOrderIndex, enableMoveUp, enableMoveDown) {
    this.updateProperties({
      currentDisplayOrderIndex: displayOrderIndex,
      enableMoveUp: enableMoveUp,
      enableMoveDown: enableMoveDown
    });

    this.updateProperties({
      isModified: this.resolveIsModified()
    });
  }

  editMemoContent(htmlContent) {
    if (htmlContent === this.currentHtmlContent)
      return;

    this.updateProperties({
      currentHtmlContent: htmlContent
    });

    this.updateProperties({
      isModified: this.resolveIsModified()
    });
  }
}